<div class="modal-header">
  <h5 class="modal-title">
    {{ title }}
  </h5>
</div>

<div class="modal-body p-4">
  <ng-container *ngIf="contentIsHtml">
    <div [outerHTML]="content"></div>
  </ng-container>

  <ng-container *ngIf="!contentIsHtml">
    {{ content }}
  </ng-container>

  <div class="form-check mt-3" *ngIf="checkboxLabel">
    <input type="checkbox" class="form-check-input" id="confirmModalCheckbox"
      [(ngModel)]="checkboxChecked">
    <label class="form-check-label" for="confirmModalCheckbox">{{ checkboxLabel }}</label>
  </div>

  <div class="mt-3" *ngIf="dateLabel">
    <div class="input-group">
      <div class="form-floating flex-grow-1">
        <!-- maxDate is optional here: ng-bootstrap types the input as required
             but null-checks it at runtime, where absent means "no maximum". -->
        <input type="text" class="form-control" id="confirmModalDate" [placeholder]="dateLabel"
          inputmode="numeric" autocomplete="off" ngbDatepicker appDateInputMask container="body"
          #confirmDp="ngbDatepicker" [maxDate]="dateMaxDate!" [(ngModel)]="dateValue">
        <label for="confirmModalDate">{{ dateLabel }}</label>
      </div>
      <button type="button" class="btn btn-light" (click)="confirmDp.toggle()">
        <fa-icon [icon]="faCalendar"></fa-icon>
      </button>
    </div>
    <!-- Field note sits outside the input-group to avoid layout shifts -->
    <div class="form-text" *ngIf="dateHint">{{ dateHint }}</div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn me-auto" [class]="resolvedFalseButtonClass"
    (click)="responseFalse()">
    {{ falseLabel }}
  </button>

  <button type="button" class="btn" [class]="resolvedTrueButtonClass"
    [disabled]="trueButtonDisabled"
    (click)="responseTrue()">
    {{ trueLabel }}
  </button>
</div>
